import styled from 'styled-components';

const CheckboxGrid = styled.div`
  border-top: 1px solid #aaaaaa;
  border-bottom: 1px solid #aaaaaa;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 equal columns */
  grid-template-rows: repeat(2, auto);
  gap: 12px;
  align-items: start;
  .info-icon {
    color: ${({ theme }) => theme.colors.primary};
    margin-left: 2px;
  }
`;

export { CheckboxGrid };
